





































import Vue from 'vue';
import {API, getDesserts} from '@/api';

export default Vue.extend({
  data: () => ({
    headers: [
      { text: 'Propietario', value: 'propietario.nombre' },
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Monto cobro', value: 'monto' },
      { text: 'Banco', value: 'cuenta.banco' },
      { text: 'Cuenta Banco', value: 'cuenta.numCuenta'},
    ],
    precision: 2,
    total: 0,
    cobros: [],
    loading: true,
    options: {itemsPerPage: 100},
  }),
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getCobroList', {admin, condo, options: this.options});
        console.debug('getCuentasList result: %o', result);
        this.total = result.totalElements;
        this.cobros = result.content;
        console.debug('COBRO_LIST: %o', this.cobros);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    fecha(item) {
      const fecha = this.$moment(item.fecha).format('DD/MM/YYYY');
      return fecha;
    },
  },
});
